export class Easel {
  id: bigint;
  type: bigint;
  family: bigint;
  name: string;
  desc: string;
  sides: number;
  stacks: number;
  width: number;
  height: number;
  depth: number;
  weight: number;
  max_width: number;
  max_height: number;
  safety_margin: number;
  max_weight: number;
  id_freight: bigint;
  utilization: number;
  thickness: number;
  separator: number;
  stack_distance: number;
  priority: number;
  cost_m3: number;
  active: boolean;
}
